// Arquivos do PDF Edit (0.50) no navegador: ficam na memória enquanto a página estiver aberta.
export type Escolhido = { nome: string; uri: string; mime: string; tamanho: number };

function escolher(accept: string, multiplo: boolean): Promise<Escolhido[]> {
  return new Promise(res => {
    const inp = document.createElement('input');
    inp.type = 'file'; inp.accept = accept; inp.multiple = multiplo;
    inp.onchange = () => res(Array.from(inp.files ?? []).slice(0, 50).filter(f => f.size <= 100 * 1024 * 1024)
      .map(f => ({ nome: f.name, uri: URL.createObjectURL(f), mime: f.type, tamanho: f.size })));
    inp.click();
  });
}
export const escolherPdfs = (multiplo = true) => escolher('application/pdf,.pdf', multiplo);
export const escolherImagens = () => escolher('image/*', true);
export const escolherQualquer = () => escolher('*/*', true);

export async function lerArquivo(uri: string): Promise<Uint8Array> { return new Uint8Array(await (await fetch(uri)).arrayBuffer()); }
const urls = new Map<string, string>();
export async function gravarArquivo(id: string, bytes: Uint8Array, ext = '.pdf'): Promise<string> {
  const velho = urls.get(id); if (velho) URL.revokeObjectURL(velho);
  const u = URL.createObjectURL(new Blob([bytes as BlobPart], { type: ext === '.pdf' ? 'application/pdf' : 'application/octet-stream' }));
  urls.set(id, u);
  return u;
}
export function apagarArquivoPdf(uri?: string) { if (!uri) return; for (const [k, v] of urls) if (v === uri) { URL.revokeObjectURL(v); urls.delete(k); } }
export const existeArquivo = (uri?: string) => !!uri && [...urls.values()].includes(uri);
